module.exports = __webpack_public_path__ + "img/8c4e89dca54fd86bac523e0e356ec7b4.4a7cd47b.png";